import React from "react";
import { SignIn } from "@clerk/clerk-react";

function LoginPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-yellow-50">
      <h1 className="text-3xl font-bold mb-6">Login</h1>
      <div className="w-full max-w-sm">
        <SignIn 
          appearance={{
            elements: {
              formButtonPrimary: 'bg-yellow-500 hover:bg-yellow-600',
              footerActionLink: 'text-yellow-500 hover:text-yellow-600'
            }
          }}
        />
      </div>
    </div>
  );
}

export default LoginPage;
